import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatTime(time: string): string {
  const [hours, minutes] = time.split(":");
  const h = parseInt(hours);
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 || 12;
  return `${h12}:${minutes} ${ampm}`;
}

/**
 * Format a review date as a friendly relative label:
 * - This year: "N month(s) ago" (or "This month")
 * - Last calendar year: "Last year"
 * - Older: "2023"
 */
export function formatReviewDate(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return "";
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  if (isNaN(date.getTime())) return "";

  const now = new Date();
  const currentYear = now.getFullYear();
  const reviewYear = date.getFullYear();

  if (reviewYear === currentYear) {
    const monthDiff = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());
    if (monthDiff <= 0) return "This month";
    return `${monthDiff} ${monthDiff === 1 ? "month" : "months"} ago`;
  }
  if (reviewYear === currentYear - 1) {
    return "Last year";
  }
  return String(reviewYear);
}
